<div fxLayout="row" class="tank-filters-container">
  <div (click)="scrollLeft()" class="scroll-arrow" *ngIf="canScrollLeft">
    <i class="fa fa-caret-left"></i>
  </div>
  <div
    class="scrollable-container"
    #scrollableContainer
    fxLayout="row"
    fxLayoutGap="10px"
    fxLayoutAlign="start center"
    [fxFlex]="100"
  >
    <app-global-tank-quick-filter
      *ngFor="let filter of tankQuickFilters$ | async"
      [filterIcon]="filter.icon"
      [filterName]="filter.name | translate"
      [value]="filter.value"
      [color]="filter.color"
      [activeFilter]="(currentlySelectedQuickFilter$ | async)?.filterType === filter?.filterType"
      [class.active]="(currentlySelectedQuickFilter$ | async)?.filterType === filter?.filterType"
      [class.inactive]="(currentlySelectedQuickFilter$ | async) && (currentlySelectedQuickFilter$ | async)?.filterType !== filter?.filterType"
      (click)="onFilterClicked(filter)"
      siteUsageTracker
      [logCategory]="'TankFilters'"
      [logName]="'QuickFilterClick'"
      [logData]="filter.filterType"
    >
    </app-global-tank-quick-filter>
  </div>
  <div (click)="scrollRight()" class="scroll-arrow" *ngIf="canScrollRight">
    <i class="fa fa-caret-right"></i>
  </div>
</div>
